<soft-entity-list-input
  [readonly]="readonly"
  [placeholder]="placeholder"
  [value]="$any(value)"
  [title]="title"
  (valueChange)="setValue($event)"
  [strategy]="strategy"
  [maxDisplayed]="maxDisplayed"
  [parameters]="{current: value, parameters: parameters}"
  #input
  >
  <ng-template let-entity="entity" #entityTemplate>
    <ng-container
      *ngTemplateOutlet="
        template || defaultTemplate;
        context: { entity: entity }
      "
    ></ng-container>
  </ng-template>
</soft-entity-list-input>
<ng-template let-entity="entity" #defaultTemplate>
  @if (config?.template && (config?.template | typeof) !== 'string') {
    <ng-container *ngComponentOutlet="$any(config?.template); inputs: {item: entity}"></ng-container>
  } @else {
    @if (config?.template) {
      {{ $any(config?.template) | interpolate:entity}}
    } @else {
      {{ entity | json }}
    }
  }
</ng-template>
